<template>
  <v-container class="white" grid-list-xl fluid ma-0 pa-0><br>
    <v-toolbar flat color="white" height="55">
      <v-flex sm2 pt-6>
        <v-text-field outlined background-color="green lighten-5" dense placeholder="Search" class="caption" prepend-inner-icon="mdi-magnify" v-model="search"></v-text-field>
      </v-flex>
        <v-flex sm1>
        <v-avatar size="25" class="orange elevation-5 mx-1"><v-icon fab small dark @click="clear()">mdi-close</v-icon></v-avatar>
      </v-flex>
        <v-spacer></v-spacer>
      <v-flex sm2>
        <v-avatar size="25" class="blue lighten-1 elevation-2 mx-1" @click.stop="add()"><v-icon right fab class="mx-2" xs-small dark @click.stop="add()">mdi-plus</v-icon></v-avatar>
        <v-avatar size="25" class="blue lighten-1 elevation-2 mx-1"><v-icon fab xs-small dark @click.stop="refresh()">mdi-autorenew</v-icon></v-avatar>
      </v-flex>
    </v-toolbar>

    <v-layout row justify-center>
      <v-dialog v-model="popupbox" max-width="700px" hide-overlay>

        <v-toolbar dark color="indigo lighten-2" height="45">
          <v-toolbar-title class="body-2">Add/Edit Sponsor Info</v-toolbar-title>
        </v-toolbar>

        <v-form ref="form" v-model="valid" lazy-validation :close-on-content-click="false" :nudge-right="100" offset-y full-width min-width="500px">
          <v-card class="elevation-1">
            <v-card-text>
              <div class="d-flex">
                <v-text-field ref="Json.name" background-color="amber lighten-5" outlined dense :rules="nameRules" class="caption mr-1" filled v-model="Json.name" label="Sponsor Name" placeholder=" " height="25" required></v-text-field>
              </div>
              <div class="d-flex">
                <v-select ref="Json.category" outlined background-color="amber lighten-5" :rules="nameRules" dense class="caption mr-1" v-model="Json.category" label="Category" :items="['Diamond', 'Platinum', 'Gold', 'Silver', 'Bronze']" placeholder=" " height="25"></v-select>
              </div>
              <div class="d-flex">
                <v-select ref="Json.type" outlined background-color="amber lighten-5" :rules="nameRules" dense class="caption mr-1" v-model="Json.type" label="Type" :items="['Photo', 'Video']" placeholder=" " height="25"></v-select>
              </div>
              <div class="d-flex">
                <v-text-field ref="Json.url" background-color="amber lighten-5" outlined dense class="caption mr-1" filled v-model="Json.url" label="Sponsor Website URL" placeholder=" " height="25"></v-text-field>
              </div>
              <div class="d-flex">
                <v-text-field ref="Json.photo" background-color="amber lighten-5" outlined dense :rules="nameRules" class="caption mr-1" filled v-model="Json.photo" label="Photo S3 URL" placeholder=" " height="25" required></v-text-field>
              </div>
              <div class="d-flex">
                <v-text-field ref="Json.order" background-color="amber lighten-5" outlined dense :rules="numberRules" class="caption mr-1" filled v-model.number="Json.order" label="Display Order" placeholder=" " height="25" type="number" required></v-text-field>
              </div>
              <v-divider></v-divider>
            </v-card-text>
            
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small outline dark color="indigo lighten-2" @click="close">Close</v-btn>
              <v-btn  v-if="Json._id !== ''" small dark outline color="indigo lighten-2" @click="update" :disabled="!valid">Update</v-btn>
              <v-btn  v-if="Json._id === ''" small dark outline color="indigo lighten-2" @click="submit" :disabled="!valid">Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="popup" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Confirmation ?</v-card-title>
          <v-card-text>Are you sure want to delete this sponsor?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="popup = false">NO</v-btn>
              <v-btn color="primary" text flat @click="confirmdeletion()">Confirm</v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-data-table dense :headers="headers" :items-per-page="50" v-bind:items="sponsorsArray" :search="search" :loading="loading" :sort-by="['order']" :sort-desc="[false]" class="elevation-0">
      <template v-slot:item.photo="{ item }">
        <v-img :src="item.photo" max-width="100" max-height="50" contain class="my-2"></v-img>
      </template>
      <template v-slot:item.url="{ item }">
        <a :href="item.url" target="_blank" v-if="item.url">{{ item.url }}</a>
        <span v-else>-</span>
      </template>
      <template v-slot:item.Edit-Delete="{ item }">
        <v-avatar size="23" class="blue lighten-1 mx-0 elevation-10"><v-icon small dark  @click=getSponsorById(item._id)>mdi-pencil</v-icon></v-avatar>
        <v-avatar size="23" class="red lighten-1 mx-2 elevation-10"><v-icon small dark  @click=deleteSponsor(item._id)>mdi-trash-can</v-icon></v-avatar>
      </template>
    </v-data-table><br><br>
    
  </v-container>
</template>

<script>
import ReportServices from '@/services/ReportServices'

export default {
  data () {
    return {
      search: '',
      loading: false,
      sponsorsArray: [],
      headers: [
        {text: 'Name', align: 'left', value: 'name'},
        {text: 'Category', align: 'left', value: 'category'},
        {text: 'Type', align: 'left', value: 'type' },
        {text: 'Photo', align: 'left', value: 'photo'},
        {text: 'Website URL', align: 'left', value: 'url'},
        {text: 'Order', align: 'left', value: 'order'},
        {text: 'Edit-Delete', align: 'left', value: 'Edit-Delete'}
      ],
      Json: {
        _id: '',
        name: '',
        url: '',
        photo: '',
        type: 'Photo',
        category: '',
        order: 1
      },
      select: null,
      valid: true,
      name: '',
      nameRules: [v => !!v || 'This Field is required'],
      numberRules: [v => v > 0 || 'Order must be greater than 0'],
      popupbox: false,
      popup: false,
      id: ''
    }
  },
  methods: {
    logoutFromFirebase () {
      this.$store.dispatch('signOutAction')
      .then(() => this.$router.replace('/Login'))
    },
    clear(){
      this.search = null
    },
    async getSponsorById (id) {
      this.cleardata ()
      if (id) {
        this.popupbox = true
        const sponsorInfo = this.sponsorsArray.find(s => s._id === id)
        if (sponsorInfo) {
          this.Json._id = sponsorInfo._id
          this.Json.name = sponsorInfo.name
          this.Json.url = sponsorInfo.url || ''
          this.Json.photo = sponsorInfo.photo
          this.Json.type = sponsorInfo.type
          this.Json.category = sponsorInfo.category
          this.Json.order = sponsorInfo.order
        }
      }
    },
    cleardata () {
      this.Json._id = ''
      this.Json.name = ''
      this.Json.url = ''
      this.Json.photo = ''
      this.Json.type = 'Photo'
      this.Json.category = ''
      this.Json.order = 1
    },
    async add () {
      this.popupbox = true
      this.cleardata ()
    },
    async submit () {
      if (this.$refs.form.validate()) {
        await ReportServices.addSponsor(this.Json)
        this.popupbox = false
        setTimeout(() => {
          this.refresh()
        }, 500)
      }
    },
    async update () {
      if (this.$refs.form.validate()) {
        await ReportServices.updateSponsor(this.Json._id, this.Json)
        this.popupbox = false
        setTimeout(() => {
          this.refresh()
        }, 200)
      }
    },
    async deleteSponsor(id) {
      this.popup = true
      this.id = id
    },
    async confirmdeletion () {
      await ReportServices.deleteSponsor(this.id)
      this.popup = false
      setTimeout(() => {
        this.refresh()
      }, 500)
    },
    async refresh () {
      this.loading = true
      this.sponsorsArray = (await ReportServices.getSponsors()).data
      this.loading = false
    },
    close () {
      this.popupbox = false
      setTimeout(() => {
        this.refresh()
      }, 100)
    }
  },
  async mounted () {
    this.refresh()
  }
}
</script>
